// change for production
// production
// const API_URL = 'https://apiespresso.azurewebsites.net/api';
const API_URL = 'https://api.ptpa.com/api';

//testing
// const API_URL = 'https://devenvironmentptpa.azurewebsites.net/api';
export default API_URL;
